import { render } from "./Home.vue?vue&type=template&id=b292de9a&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=b292de9a&scoped=true&lang=css"

import exportComponent from "/builds/dalmadima/umzugbayernwebapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b292de9a"]])

export default __exports__